import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const BasicInfo = ({ data }) => {
    const {horoscopeDataM, horoscopeDataF} = data || {};
    const { t } = useTranslation();

    const items = [
        {
            name: t("DASAWA"), 
            valueM: horoscopeDataM.dasa[0]?.dasaL1 + ' ' + horoscopeDataM.dasa[0]?.duration,
            valueF: horoscopeDataF.dasa[0]?.dasaL1 + ' ' + horoscopeDataF.dasa[0]?.duration
        },
        {
            name: t("Nekatha"),
            valueM: horoscopeDataM.nekatha + " / " + horoscopeDataM.nekathaPadaya,
            valueF: horoscopeDataF.nekatha + " / " + horoscopeDataF.nekathaPadaya
        },
          {
            name: t("Karanaya"), 
            valueM: horoscopeDataM.karanaya,
            valueF: horoscopeDataF.karanaya
        },
        // {
        //     name: t("PHorawa"), 
        //     valueM: horoscopeDataM.horaPanchama,
        //     valueF: horoscopeDataF.horaPanchama
        // },
        {
            name: t("Thithiya"), 
            valueM: horoscopeDataM.thithiya,
            valueF: horoscopeDataF.thithiya
        },
        {
            name: t("Yogaya"), 
            valueM: horoscopeDataM.yogaya,
            valueF: horoscopeDataF.yogaya
        },
         {
            name: t("Horawa"), 
            valueM: horoscopeDataM.hora,
            valueF: horoscopeDataF.hora
        },
        
        // {
        //     name: t("SHorawa"), 
        //     valueM: horoscopeDataM.horaSukshama,
        //     valueF: horoscopeDataF.horaSukshama
        // },
        
    ];

    // Split items into rows of 2 columns each
    const rows = [];
    for (let i = 0; i < items.length; i += 1) {
        rows.push(items.slice(i, i + 1));
    }

    return (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px', marginBottom: '16px' }}>
            {/* <thead>
                <tr>
                    <th style={{ textAlign: 'left', padding: '1px 4px' }}>{t("")}</th>
                    <th style={{ textAlign: 'left', padding: '1px 4px' }}>{t("Male")}</th>
                    <th style={{ textAlign: 'left', padding: '1px 4px' }}>{t("Female")}</th>
                </tr>
            </thead> */}
            <tbody>
                {rows.map((row, idx) => (
                    <tr key={idx}>
                        {row.map((item, colIdx) => (
                            <React.Fragment key={colIdx}>
                                <td style={{ fontSize: '12px', fontWeight: 'bold', padding: '1px 4px', whiteSpace: 'nowrap' }}>{item.name}</td>
                                <td style={{ fontSize: '12px', padding: '1px 2px' }}>{item.valueM}</td>
                                <td style={{ fontSize: '12px', padding: '1px 2px' }}>{item.valueF}</td>
                            </React.Fragment>
                        ))}
                        {/* Fill empty cells if row has less than 3 items */}
                        {row.length < 2 &&
                            Array.from({ length: 2 - row.length }).map((_, i) => (
                                <React.Fragment key={`empty-${i}`}>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </React.Fragment>
                            ))
                        }
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
BasicInfo.propTypes = {
    data: PropTypes.object.isRequired,
};
export default BasicInfo;